import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EntityListRefresh } from '../../../core/services/entity-list.refresh';
import { LiftBoardParameterService } from '../../services/lift-board-parameter.service';
import { UINotificationService } from '../../../core/services/ui-notification.service';
import { ModalComponent } from '../../../core/components/modal/modal.component';
import { NotificationType } from '../../../core/models/ui-notification.model';

@Component({
  selector: 'app-create-lift-board-parameter',
  templateUrl: './create-lift-board-parameter.component.html',
  styleUrls: ['./create-lift-board-parameter.component.css']
})
export class CreateLiftBoardParameterComponent implements OnInit {
  form = new FormGroup({});
  liftBoardId: number;
  parameters: any;
  groups: any;

  langs = [
    { 'lang': 'cs', 'title': 'Česky' },
    { 'lang': 'en', 'title': 'Anglicky' },
    { 'lang': 'de', 'title': 'Německy' }
  ];

  constructor(
    private route: ActivatedRoute,
    private parameterService: LiftBoardParameterService,
    private entityListRefresh: EntityListRefresh,
    private uiNotificationService: UINotificationService
  ) { }

  ngOnInit() {
    this.liftBoardId = +this.route.snapshot.paramMap.get('boardId');
    this.parameters = this.route.snapshot.data.parameters.body;
    this.groups = this.route.snapshot.data.groups.body;

    console.log(this.groups);
    console.log(this.parameters);

    this.form.addControl('groupsControl', new FormControl(this.groups[0], Validators.required));
    this.form.addControl('parametersControl', new FormControl(this.parameters[0], Validators.required));
  }

  close(modal: ModalComponent) {
    modal.closeModal(null);
  }

  onSubmit(modal: ModalComponent) {
    const lookupLang = [
      { twoLetterISOLanguageName: 'cs', title: 'parametr karty', description: 'parametr karty' },
      { twoLetterISOLanguageName: 'de', title: 'parametr karty', description: 'parametr karty' },
      { twoLetterISOLanguageName: 'en', title: 'parametr karty', description: 'parametr karty' }
    ];

    if (this.form.valid) {
      let groupsValue = this.form.get('groupsControl').value;
      let paramsValue = this.form.get('parametersControl').value;
      this.parameterService.create({
        liftBoardId: this.liftBoardId,
        parentId: groupsValue.id,
        liftParameterId: paramsValue.id,
        values: null,
        language: lookupLang
      }).subscribe(() => {
        this.entityListRefresh.refresh('lift-board-parameter');
        this.uiNotificationService.add({
          type: NotificationType.Info,
          message: 'Parametr byl přiřazen ke kartě'
        });
        modal.closeModal(null);
      });
    }
  }

}
